



































import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';
import { getStudioURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  props: {
    commentId: {
      type: Number,
      required: true,
    },
    numLikes: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tableFields: [
        {
          name: 'user',
          cssClass: 'h5 w-100',
        },
        {
          name: 'send_message',
          cssClass: 'text-nowrap',
        },
      ],
    };
  },
  computed: {
    query() {
      return {
        id: this.commentId,
      };
    },
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  methods: {
    async redirectToChat(roomId) {
      this.$router.push({
        name: 'studio-community-chat',
        params: {
          studio_url: getStudioURL(this.$route),
        },
        query: {
          room_id: roomId,
        },
      });
    },
    async createPrivateChatRoom(user) {
      try {
        this.$emit('close');

        const privateRoom = await this.$store.dispatch(
          'community/createPrivateChatRoom',
          {
            studioURL: this.studioURL,
            member: user.id,
          }
        );
        this.redirectToChat(privateRoom.id);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1,
        });
      }
    },
  },
});
